import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    accounts: []
};
var accountsSlice = createSlice({
    initialState: initialState,
    name: "accounts",
    reducers: {
        setAccounts: function(state, param) {
            var payload = param.payload;
            state.accounts = payload;
        }
    }
});
export var setAccounts = accountsSlice.actions.setAccounts;
export var accountsReducer = accountsSlice.reducer;

//# sourceMappingURL=accounts.js.map